import { PATHNAMES } from "@/shared";
import { IDealer } from "@/entities/dealer";

const { nomenclaturePath, ordersPath, remainsPath } = PATHNAMES;

export enum CartProductKeysEnum {
  image = " ",
  vendorCode = "Артикул",
  fullName = "Наименование",
  filialCol = "Филиал",
  dealerPrice = "Цена дилер (₽)",
  quantity = "Кол-во (шт)",
  totalPrice = "Стоимость (₽)",
}

export type CreateOrderResponse = {
  orderId: string;
  orderNumber: string;
  isSuccess: boolean | null;
  vendorNumbers: string[];
  isUpdated: boolean;
};

export type CartFilialsType = {
  basketId: string;
  dealerId: string;
  dealerName: string;
  dealerShortName: string;
  quantity: number;
  isMain: boolean;
};

export type CartProductType = {
  modelName: string;
  fullName: string;
  vendorId: string;
  vendorCode: string;
  image: null | string;
  canOrdered: boolean;
  dealerPrice: number;
  exporterPrice: number;
  retailPrice: number;
  wholesalePrice: number;
  basketFilials: CartFilialsType[];
  totalPrice: number;
  quantity?: number;
  remainQuantity?: number;
  orders: {
    number: string;
    value: number;
  }[];
  filialCol?: string;
  code?: string;
  designName?: string;
};

// Продавец товара в корзине остатков партнеров: его цена, остаток
// и количества по филиалам покупателя
export type DealerRemainsSellerType = {
  sellerDealerId: string;
  sellerDealerName: string | null;
  dealerPrice: number | null;
  remainQuantity: number;
  basketFilials: CartFilialsType[] | null;
};

export type DealerRemainsProductType = {
  modelName: string | null;
  fullName: string | null;
  vendorId: string;
  vendorCode: string | null;
  image: string | null;
  canOrdered: boolean;
  orders: { number: string; value: number }[] | null;
  sellerDealers: DealerRemainsSellerType[] | null;
};

export interface DealerRemainsCartResponse {
  items: DealerRemainsProductType[] | null;
  totalCount: number;
}

// Строка корзины «артикул × продавец»; у остатков СКАД продавца нет
export type BasketQtySourceItem = {
  vendorId: string;
  sellerDealerId?: string | null;
  basketFilials: CartFilialsType[] | null;
};

export type ItemToCart = {
  vendorId: string;
  quantity: number | string;
  filialId?: string;
  sellerDealerId?: string;
};

export type CartType = "production" | "remains" | "dealerRemains";

export type CartSummaryOrderType = 1 | 2 | 3;

export type DealerOrderInfo = {
  id: string;
  orderNumber: string | null;
  dealerId: string;
  buyerDealerName: string | null;
  sellerDealerId: string | null;
  sellerDealerName: string | null;
  created: string;
  totalAmount: number;
  itemsCount: number;
};

export type CreateDealerOrderResult = {
  data: DealerOrderInfo[] | null;
};

export type DealerRemainsSortType = {
  field: string;
  type: "asc" | "desc";
};

export type ChangeItemToCart = {
  itemId: string;
  quantity: number;
  filialId: string;
};

export type NewOrderResponseType = {
  orders: CreateOrderResponse[];
};
export type PathFromType =
  | typeof nomenclaturePath
  | typeof remainsPath
  | typeof ordersPath;

export type CartSliceState = {
  totalCount: number;
  error: null | string | unknown;
  isLoading: boolean;

  productionItems: CartProductType[];
  selectedProdItems: string[];
  allProdIds: string[];
  allBasketProdIds: string[];
  allFilialsProdIds: string[];
  totalProdPrice: number;
  totalProdCount: number;
  isLoadingProd: boolean;

  remainsItems: CartProductType[];
  selectedRemainsItems: string[];
  allRemainsIds: string[];
  allBasketRemainsIds: string[];
  allFilialsRemainsIds: string[];
  totalRemainsPrice: number;
  totalRemainsCount: number;
  isLoadingRemain: boolean;

  dealerRemainsItems: DealerRemainsProductType[];
  hasDealerRemainsCart: boolean;
  isLoadingDealerRemain: boolean;
  totalDealerRemainsCount: number;
  dealerRemainsPageSize: number;
  dealerRemainsPageNumber: number;
  dealerRemainsTotalPageNumber: number;
  dealerRemainsSort: DealerRemainsSortType | null;
  collapsedDealerRemainsIds: string[];
  selectedDealerRemainsBasketIds: string[];
  newDealerRemainsOrder: DealerOrderInfo[] | null;

  totalCartCount: number;

  excludeItems: (keyof CartProductType)[];

  newRemainsOrder: CreateOrderResponse[] | null;
  from: PathFromType;

  mainFilial: IDealer | null;
  filalsProdIdsToShow: string[];
  filalsRemainsIdsToShow: string[];

  dealersProdIdsToShow: string[];
  dealersRemainsIdsToShow: string[];

  canCreateOrder: boolean;
  deleteMode: boolean;

  productionOrder: { type: "asc" | "desc"; field: string };
  remainsOrder: { type: "asc" | "desc"; field: string };
  productionPageSize: number;
  remainsPageSize: number;
  productionPageNumber: number;
  remainsPageNumber: number;
  productionTotalPageNumber: number;
  remainsTotalPageNumber: number;

  productionDefaultOrder: { type: "asc" | "desc"; field: string };
  remainsDefaultOrder: { type: "asc" | "desc"; field: string };

  productionFilters: CartFilterType | [];
  remainsFilters: CartFilterType | [];
  selectedProductionFilters: CartFilterItemType;
  selectedRemainsFilters: CartFilterItemType;
  filtersLoading: boolean;
  filtersError: string | null;

  productionFilterItems: CartFilterItemType;
  remainsFilterItems: CartFilterItemType;
};

export type TotalInfoType = {
  totalQuantity: number;
  totalPrice: number;
  totalRemainsQuantity?: number;
};

export type CartFilterType = {
  type: string;
  fields: CartFilterItemType | null;
  params?: { dealerId: string };
}[];

export type CartFilterItemType = Partial<
  Record<keyof CartProductType, string[]>
>;

export interface CartResponse {
  items: CartProductType[];
  totalCount: number;
}

export interface CartSummaryResponse {
  totalQuantity: number;
}

export { nomenclaturePath, ordersPath, remainsPath };
